import styled from 'styled-components';
import ChevronLeft from 'mdi-react/ChevronLeftIcon';
import ChevronRight from 'mdi-react/ChevronRightIcon';
import { layout } from '@prisjakt/ui-base';
import Clickable from '@prisjakt/ui-clickable';

const padding = layout.spacing.xSmall;

export const ListItem = styled(Clickable)`
  color: ${props => props.theme.text.primary};
  cursor: pointer;
  min-height: 50px;
  padding: ${layout.spacing.xxSmall} ${padding};
  text-align: left;
  display: flex;
  align-items: center;

  /* Set the width and box-sizing to account for inconsistencies between <button> and <a> */
  box-sizing: border-box;
  width: 100%;

  &:hover {
    background-color: ${props => props.theme.bg.secondary};
  }
`;

export const Image = styled.div`
  margin-right: ${padding};
`;

export const Name = styled.span`
  flex: 1 1 auto;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CallToAction = styled.span`
  color: ${props => props.theme.text.callToAction};
  margin-left: ${padding};
  text-align: right;
`;

export const RightArrow = styled(ChevronRight).attrs({ size: 20 })`
  flex: 0 0 auto;
  margin-left: ${padding};
  path {
    fill: currentColor;
  }
`;

export const LeftArrow = styled(ChevronLeft).attrs({ size: 20 })`
  flex: 0 0 auto;
  margin-right: ${padding};
  path {
    fill: currentColor;
  }
`;
